(function () {
    "use strict";

    angular.module("app").factory("fvmRequestHelper", FvmRequestHelper);

    FvmRequestHelper.$inject = ["$filter", "enumService"];
    function FvmRequestHelper($filter, enumService) {
        const fields = {
            getTranslation: $filter("habilTranslation"),
        };

        const fvmInitialActions = enumService.FvmInitialActions;

        return {
            GetInitialActionText: getInitialActionText,
            GetInitialActionIcon: getInitialActionIcon
        };

        function getInitialActionText(request) {
            const initialAction = Number.parseInt(request.InitialAction);
        
            switch (initialAction) {
                case fvmInitialActions.New:
                    return fields.getTranslation("RequestFVM_InitialAction_New");
                case fvmInitialActions.Change:
                    return fields.getTranslation("RequestFVM_InitialAction_Change");
                case fvmInitialActions.Renew:
                    return fields.getTranslation("RequestFVM_InitialAction_Renew");
                case fvmInitialActions.Remove:
                    return fields.getTranslation("RequestFVM_InitialAction_Remove");
            }
            return null;
        }

        function getInitialActionIcon(request) {
            const initialAction = Number.parseInt(request.InitialAction);
        
            switch (initialAction) {
                case fvmInitialActions.New:
                    return "fa fa-plus";
                case fvmInitialActions.Change:
                    return "fa fa-edit";
                case fvmInitialActions.Renew:
                    return "fa fa-repeat";
                case fvmInitialActions.Remove:
                    return "fa fa-times";
            }
            return null;
        }
    }
})();
